module.exports = ".ibd_item {\n  margin-top: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/inbox/email-detail/email-detail.component.scss
// module id = ./client/app/inbox/email-detail/email-detail.component.scss
// module chunks = main